// ============================================================
// Interruptores de funcionalidades do painel. Para mudar, edite
// aqui e publique (push na main).
// ============================================================

// Cadastro público de novos sócios: tela /register e o link "Cadastre-se"
// no login e na recuperação de senha. Desativado em 19/10/2026 — quem
// abrir o endereço do cadastro vê um aviso (RegisterDisabledPage). O
// formulário e a tela de sucesso continuam no código; para reativar,
// basta voltar para true e publicar.
export const PUBLIC_REGISTRATION_ENABLED: boolean = false;
